window.tanDiff = 20;
export const getTanBlob = (pts,x,y) => {
    // for each pt

    // calculate the tan
    let blob = [];

    for (let i=0; i < pts.length; i++) {
        let ptA = pts[i];
        let ptB = pts[(i+1)%pts.length];
        let xA = ptA.x - x;
        let yA = ptA.y - y;
        let xB = ptB.x - x;
        let yB = ptB.y - y;


        let controlA  = calculate(
            xA, yA, window.tanDiff);
        controlA = {x: controlA.x1 + x, y: controlA.y1 + y};
        let controlB  = calculate(
            xB, yB, window.tanDiff);
        controlB = {x: controlB.x1 + x, y: controlB.y1 + y};
        if (i===0) {
            blob.push(
                [
                    controlA,
                    controlB,
                    ptB
                ]);
        } else {
            blob.push(
                [
                    ptA,
                    controlB,
                    ptB
                ]);
        }
    }
    return blob;
};

const calculate = (x, y, d) => {
    let term = sqrt((sq(d/x) - 1)/(1 - sq(y/x)) + sq(y));
    let y1 = y + term;
    let y2 = y - term;
    let x1 = 2*x - (y1*x/y);
    let x2 = 2*x - (y2*x/y);
    return {
        x1,y1,x2,y2
    };
};

const sq = (x) => Math.pow(x, 2);
const sqrt = Math.sqrt;
